import React from 'react';

import IconCheckList from '@components/icons/IconCheckList';
import IconAddFile from '@components/icons/IconAddFile';
import Icon3RnDLogo from '@components/icons/Icon3RnDLogo';

export const asedaCards = [
  {
    title: 'SciScore Product Website',
    authorizedOnly: false,
    newTab: true,
    icon: <img src={'/img/SciScore_Logo.svg'} alt={'SciScore'} width={64} />,
    link: 'https://sciscore.asedasciences.com',
    description: 'Find more about the SciScore product.',
  },
  {
    title: 'AsedaSciences Website',
    authorizedOnly: false,
    newTab: true,
    icon: <img src={'/img/AsedaSciences_logo.svg'} alt={'AsedaSciences'} width={64} />,
    link: 'https://asedasciences.com',
    description: 'Find more Company information at the AsedaSciences website.',
  },
  {
    title: '3RnD Product Website',
    authorizedOnly: false,
    newTab: true,
    icon: <Icon3RnDLogo size={64} />,
    link: 'https://3rnd.asedasciences.com',
    description: 'Learn about 3RnD, Aseda Sciences\' Premier AI-enabled Research Platform',
  }
];

export const sciScoreCards = [
  {
    title: "My Submissions",
    authorizedOnly: true,
    newTab: false,
    icon: <IconCheckList size={64} />,
    link: "/submissions",
    description: "Table view of My Submissions",
  },
  {
    title: "New Submission",
    authorizedOnly: true,
    newTab: false,
    icon: <IconAddFile size={64} />,
    link: "/submissions/create",
    description: "Create new submission",
  }
];


